module.exports = "<div class=\"toggle-switch\" [ngClass]=\"cssClass()\"><div class=\"toggle-switch__positive\" (click)=\"selectPositive()\">{{ positiveLabel }}</div><div class=\"toggle-switch__negative\" (click)=\"selectNegative()\">{{ negativeLabel }}</div></div>"


//////////////////
// WEBPACK FOOTER
// ./app/common/forms/toggle-switch.component.html
// module id = 1123
// module chunks = 4